import { Box, Button, Typography } from "@mui/material";
import useStyles from "./index.styles";

interface TransportButtonProps {
  type: string;
  cost: number;
  onClick: () => void;
  disabled?: boolean;
}

export const TravelTransportButton = ({
  type,
  cost,
  onClick,
  disabled,
}: TransportButtonProps) => {
  const { classes } = useStyles();

  return (
    <Button
      className={classes.moneyCopyButton}
      onClick={onClick}
      disabled={disabled}
    >
      <Typography>{type}</Typography>
      <Box
        component="img"
        src="/assets/imgs/layout/currency.png"
        alt="currency"
      />
      <Typography>{cost}</Typography>
    </Button>
  );
};
